import {
  companyHasSinglePermission,
  userHasAnyPermission,
  userHasSinglePermission,
} from 'util/PermissionsUtils';
import { Permission, Permission as P } from 'common/models/Permissions';

export const AllowPlacementsModule = () =>
  userHasSinglePermission(P.Placements) && companyHasSinglePermission(P.Placements);
export const AllowPlacementsAddEdit = () =>
  userHasSinglePermission(P.PlacementsAddEdit) && companyHasSinglePermission(P.PlacementsAddEdit);
export const AllowPlacementsDelete = () =>
  userHasSinglePermission(P.PlacementsDelete) && companyHasSinglePermission(P.PlacementsDelete);
export const AllowPlacementsReportsAccess = () => userHasSinglePermission(P.PlacementsReports);
export const AllowFinancialController = () => userHasSinglePermission(P.FinancialController);
export const AllowPlacementsImport = () =>
  userHasAnyPermission([Permission.OfficeAdministrator, Permission.SystemAdministrator]);
